import { render, staticRenderFns } from "./SupplyPointList.vue?vue&type=template&id=52741792"
import script from "./SupplyPointList.vue?vue&type=script&lang=js"
export * from "./SupplyPointList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports